/**
 * Will return the route formattted
 *
 * @param {string} route string of the route
 * @param {string} field field that will be shown
 * @param {string} replace replace on the route
 */
export const getLinkRoute = (route: string, field: string, replace: string) =>
    `${route}`.replace(`{${field}}`, replace);
